<template>
  <div>
    <div class="flex flex-col mt-2">
      <!-- Barra: a la izquierda la configuración (abre modal con el switch de tipo de
           progreso); a la derecha las acciones CRUD. Botones con el estilo de BOQ
           (.epc-data-table__action-btn, clases globales). -->
      <div class="top-bar flex justify-between items-center gap-2">
        <button type="button" class="epc-data-table__action-btn" @click="openConfigModal">
          <b-icon pack="fas" icon="cog" size="is-small" />{{ $t('configuration') }}
        </button>

        <div class="flex gap-2">
          <button type="button" class="epc-data-table__action-btn" @click="addGroup" :disabled="showFormLinkGroup">
            <b-icon pack="fas" icon="plus" size="is-small" />{{ $t('add_group') }}
          </button>

          <button type="button" class="epc-data-table__action-btn" @click="openImportModal"
            :disabled="showFormData || showFormLinkGroup">
            <b-icon pack="fas" icon="file-import" size="is-small" />{{ $t('import') }}
          </button>

          <button type="button" class="epc-data-table__action-btn" @click="exportGroups"
            :disabled="showFormData || showFormLinkGroup">
            <b-icon pack="fas" icon="file-export" size="is-small" />{{ $t('export') }}
          </button>
        </div>
      </div>

      <div :class="[( showFormData || showFormLinkGroup ? 'w-7/12' : 'w-full'), 'mr-2', 'mt-2']">
        <activity-groups-list ref="list_groups" :entity-type="entityType" :entity-id="projectId"
          :disabled-menu-actions="showFormData || showFormLinkGroup"
          @add-group="handleAddGroup" @edit-group="handleEditGroup" @link-group="handleLinkGroup"
          @drop-group="handleDropGroup"></activity-groups-list>
      </div>

      <!-- Modals -->
      <activity-group-edit-modal ref="refEditModal"
        :entity-type="entityType"
        :entity-id="projectId"
        @epc-success-creating="handleSuccess"/>

      <activity-group-link-modal ref="refLinkModal"
        :project-id="projectId"
        :entity-type="entityType"
        @epc-success-link="() => { $ref.refLinkModal.hide() }"/>
    </div>

    <!-- Importar en modal (mismo patrón que BOQ) -->
    <epc-modal-wrapper
      :active.sync="showImportModal"
      :title="$t('import')"
      :width="'92vw'"
      :can-cancel="['escape']"
      scroll-body
    >
      <div class="w-full">
        <import-entities v-if="showImportModal"
          :can-overwrite="true"
          :project-id="projectId"
          :withHistory="false"
          :entity-type="'activity-groups'"
          :morph-type="entityType"
          @success="handleImportSuccess"
        />
      </div>
      <template #footer>
        <button class="epc-modal__button" @click="showImportModal = false">{{ $t('close') }}</button>
      </template>
    </epc-modal-wrapper>

    <!-- Configuración del tipo de progreso de grupos (switch) en modal -->
    <epc-modal-wrapper
      :active.sync="showConfigModal"
      :title="$t('group_progress_configuration')"
      :width="'640px'"
      :can-cancel="['escape', 'outside']"
      scroll-body
    >
      <div class="w-full">
        <activity-groups-config v-if="showConfigModal" :project-id="projectId" />
      </div>
      <template #footer>
        <button class="epc-modal__button" @click="showConfigModal = false">{{ $t('close') }}</button>
      </template>
    </epc-modal-wrapper>
  </div>
</template>

<script>
import Form from "vform";
import axios from "axios";
import ActivityGroupsList from './activity-groups-list.vue';
import ActivityGroupEditModal from './components/edit-modal.vue';
import ActivityGroupsConfig from './activty-groups-config.vue';
import ImportEntities from '../../components/import-entities';
import ActivityGroupLinkModal from './components/link-modal.vue';
import EpcModalWrapper from '../epc-modal-wrapper.vue';

export default {
  name: "manage-groups-activities",

  components: {
    ActivityGroupsList,
    ActivityGroupEditModal,
    ActivityGroupLinkModal,
    ActivityGroupsConfig,
    ImportEntities,
    EpcModalWrapper,
  },

  data: () => ({
    group: null, // objeto que se crea
    showFormData: false,
    showFormLinkGroup: false,
    groups: [], // unidades de la compania
    showImportModal: false,
    showConfigModal: false,
  }),

  props: {
    projectId: { type: Number, required: true },
    entityType: { type: String, required: true } // el entityType para el componente activity groups import pasa a ser el morphType
  },

  created() {
    this.getGroups()
  },

  methods: {
    async getGroups() {
      this.groups = []

      const {data} = await axios.get('/api/v2/project/'+ this.projectId + '/activity/groups', {params: { full_tree: 1 }}) // gestión necesita la jerarquía completa
      if (data && data.success) {
        this.groups = data.groups
      }
    },

    async exportGroups() {
      const {data} = await axios.get('/api/v2/export/activity-groups', {
        params: {
          projectable_id: this.projectId,
          projectable_type: 'project',
        }
      })
      if (data && data.success) {
        const url = data.url
        window.open(url, '_blank')

        this.$notify.success('success_exporting_groups')
      }
    },

    openImportModal() {
      this.showImportModal = true
    },

    openConfigModal() {
      this.showConfigModal = true
    },

    handleImportSuccess() {
      this.showImportModal = false
      this.$refs.list_groups.reload()
    },

    addGroup() {
      this.group = null
      this.$refs.refEditModal.show(this.group); // Resetea el formulario del modal
    },

    handleOnCloseEdit(event) {
      this.showFormData = !event
    },

    handleSuccess() {
      this.showFormData = false
      this.$refs.list_groups.reload()
      this.$refs.refEditModal.hide(); // Cierra el modal de edición
    },

    handleAddGroup(group) {
      this.group = group
      this.$refs.refEditModal.show(this.group); // Resetea el formulario del modal
    },

    handleEditGroup(group) {
      this.group = group
      this.$refs.refEditModal.show(this.group); // Resetea el formulario del modal
    },

    handleLinkGroup(group) {
      this.group = group
      this.$refs.refLinkModal.show(this.group);
    },

    async handleDropGroup(group) {
      let form = new Form({
        id: group.id,
        entity_type: this.entityType,
        parent_id: group.parent_id === group.id ? null : group.parent_id,
        code: group.code,
        name: group.name,
        weight: group.weight,
        color: group.color,
        order_column: group.order_column,

      })

      let url = `/api/v2/activity/groups/${group.id}`; // se edita el grupo

      const { data } = await form.post(url).catch((error) => { console.log(error) })

      if (data && data.success) {

        this.$notify.success('success_editing')

        if( data.warning )
          this.$notify.warning(data.warning)
        this.handleSuccess();
      } else {
        this.processingData = false
        if( data && data.message )
          this.$notify.error(data.message)
        else
          this.$notify.error('error_creating_group')
      }
    },
  }

};
</script>

<style scoped>
</style>
